import { Button } from '@material-ui/core';
import en from '../../../../lang/en-us';
import UploadDocumentScreen from '../UploadDocumentScreen';
const { dashboard } = en;

export default function ChangeBankDocument() {
    return (
        <div className="curved-bg">
            <UploadDocumentScreen
                backLink="nct/change-bank-selected"
                heading={dashboard.ChangeBank.ChangeBankHeading}
                subheading={dashboard.changeEmail.UploadDocument.subHeading}
                info1={dashboard.changeEmail.UploadDocument.subHeadingInfo1}
                linkText={dashboard.changeEmail.UploadDocument.subHeadingInfo2}
                info2={dashboard.changeEmail.UploadDocument.subHeadingInfo3}
                nextLink="nct/change-bank-success"
            />
        </div>
    );
}
